// extracted by mini-css-extract-plugin
module.exports = {"emojiContainer":"Emoji_emojiContainer__3VF9H","emoji":"Emoji_emoji__1UFmY","emojiIcon":"Emoji_emojiIcon___3iHf","open":"Emoji_open__epNVV"};